require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-gdpr-compliance-software-challenges.json") })
        }
      }, "path---blog-gdpr-compliance-software-challenges");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-gdpr-compliance-software-challenges!./.cache/json/blog-gdpr-compliance-software-challenges.json
// module id = 824
// module chunks = 231608221292675